import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  JbActionLinkModule,
  JbButtonModule,
  JbIconModule,
  JbImageModule,
} from 'jb-component-library';

import { JbFamilyBrandBlockComponent } from './jb-family-brand-block.component';

@NgModule({
  declarations: [JbFamilyBrandBlockComponent],
  imports: [
    CommonModule,
    JbImageModule,
    JbButtonModule,
    JbIconModule,
    JbActionLinkModule,
  ],
  exports: [JbFamilyBrandBlockComponent],
})
export class JbFamilyBrandBlockModule {}
